import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap/lib';
import classNames from 'classnames';

import './mobile-links.scss';

export function MobileLinks(props) {
  const { linksList, className } = props;
  if (!(linksList && linksList.length)) return null;

  return (
    <Row className={classNames('mobile-links', className)}>
      <Col>
        <div className="mobile-links-list">
          {linksList.map(link => (
            <div key={`${link.name}_${link.href}`} className="list-item">
              <a
                href={link.href}
                target={link.target}
                rel={link.rel}
                data-tracking-id={link.tracking}
                data-tracking-value={link.trackingValue}
                className="list-link d-block"
                onClick={link.onClick}
              >
                {link.name} <span className="list-link-icon icon-arrow-right3 float-end" aria-hidden />
              </a>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
}

MobileLinks.propTypes = {
  linksList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
      rel: PropTypes.string,
      tracking: PropTypes.string,
      trackingValue: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  className: PropTypes.string,
};

MobileLinks.defaultProps = {
  linksList: [],
  className: '',
};
